import React from 'react';
import ProjectDetailView from 'components/ProjectDetailView/ProjectDetailView';
import feelData from './data';

const Feel = () => {
  return <ProjectDetailView data={feelData} />;
};

export default Feel;
